import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ModalModule } from 'app/modal/modal.module';
import { CreateProcessModule } from 'app/createProcess/createProcess.module';
import { EditProcessModule } from 'app/editProcess/editProcess.module';
import { PreviewProcessModule } from 'app/previewProcess/previewProcess.module';
import { ExecuteProcessModule } from 'app/executeProcess/executeProcess.module';
import { ProcessCategoriesModule } from 'app/processCategories/processCategories.module';
import { SearchProcessesModule } from 'app/searchProcesses/searchProcesses.module';
import { MaskDirectiveModule } from 'app/shared/directives/mask.directive/mask.directive.module';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { HomeModule } from './home/home.module';
import { AboutModule } from './about/about.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    TranslateModule.forRoot(),
    MDBBootstrapModule.forRoot(),
    MDBBootstrapModulePro.forRoot(),
    CoreModule,
    SharedModule,
    HomeModule,
    AboutModule,
    CreateProcessModule,
    EditProcessModule,
    PreviewProcessModule,
    ExecuteProcessModule,
    ProcessCategoriesModule,
    SearchProcessesModule,
    AppRoutingModule,
    ModalModule,
    MaskDirectiveModule.forRoot()
  ],
  declarations: [AppComponent],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/app.module.ts